export const GATEWAY_API_VERSION = 'v1';
export const GATEWAY_API_PATH = 'message-gateway';
export const GATEWAY_AUTH_PATH = 'auth';

// Gateway API configuration - centralized for all chat and real-time features
export const getBaseApiUrl = (): string => {
  return import.meta.env.VITE_BASE_API_URL;
};

export const getGatewayOrigin = (): string => {
  return getBaseApiUrl();
};

export const getGatewayApiVersion = (): string => {
  return `${GATEWAY_API_VERSION}/${GATEWAY_API_PATH}`;
};

export const getGatewayApiBase = (): string => {
  return `${getGatewayOrigin()}/${GATEWAY_API_VERSION}/${GATEWAY_API_PATH}`;
};

export const getGatewayAuthBase = (): string => {
  return `${getBaseApiUrl()}/${getGatewayApiVersion()}`;
};
